import script from "./CalendarEventCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarEventCard.vue?vue&type=script&setup=true&lang=js"

import "./CalendarEventCard.vue?vue&type=style&index=0&id=75ff7153&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75ff7153"]])

export default __exports__